import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IshodNastavneJedinicePopisService } from './ishod-nastavnejedinice-popis.service';
import { IshodNastavneJedinicePopis } from './ishod-nastavnejedinice';
import { Subject } from 'rxjs';
import * as toastr from 'toastr';
import * as alertify from 'alertify.js';
declare var $: any;

@Component({
  selector: 'app-ishod-nastavnejedinice-popis',
  templateUrl: './ishod-nastavnejedinice-popis.component.html',
  styleUrls: ['./ishod-nastavnejedinice-popis.component.css'],
  providers: [IshodNastavneJedinicePopisService]
})
export class IshodNastavneJedinicePopisComponent implements OnInit {

  ishodNastavneJediniceEditForma: FormGroup;
  ishodiucenjaForma: FormGroup;
  ishodNastavneJediniceAddForma: FormGroup;

  ishodiNastavneJedinice = [];
  ishodiNastavneJediniceTrigger: Subject<IshodNastavneJedinicePopis> = new Subject();
  imaIshoda: boolean = false;
  dodajIshodGumb: boolean = false;
  idPodrucjeZnanjaPrivremeno: number;
  idNastavnaJedinica: number;
  svapodrucjaznanja: any = [];
  sviaktivnimodulipopis: any = [];

  ishodiOptions: DataTables.Settings = {};

  constructor(
    private _fb: FormBuilder,
    private _ishodNastavneJedinicePopisService: IshodNastavneJedinicePopisService
  ) { }

  ngOnInit() {
    this.ishodiucenjaForma = this._fb.group({
      podrucjeZnanja: [''],
      nastavnaJedinica: [''],
      ishodUcenja: ['']
    });
    this.ishodNastavneJediniceEditForma = this._fb.group({
      idishodinastavnihjedinica: [''],
      ishodinaziv: [''],
      idmodul: ['']
    });
    this.ishodNastavneJediniceAddForma = this._fb.group({
      sadrzaj: [''],
      idNastavnaJedinica: ['']
    });
    this.dohvatiAktivneModulePopis();
    this.dohvatiSvaPodrucjaznanja();
    this.ishodiOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
        targets: 'no-sort',
        orderable: false
      }],
      retrieve: true
    };
  }

  // dohvatiIshodeNastavneJedinice(){
  //   this.dohvatiSvaPodrucjaznanja();
  // }

  dohvatiAktivneModulePopis(){
    this.sviaktivnimodulipopis = [];
    this._ishodNastavneJedinicePopisService.dohvatiAktivneModule({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviaktivnimodulipopis.push({
            'id': res.data[i]['idmodul'],
            'naziv': res.data[i]['mo_naziv'],
            'idnacinpredavanja': res.data[i]['idnacinpredavanja'], 
            'nacinpredavanja': res.data[i]['np_naziv'],
            'idpodrucjeznanja': res.data[i]['idpodrucjeznanja'],
            'podrucjeznanja': res.data[i]['pu_naziv'],
            'aktivan': res.data[i]['mo_aktivan']
          });
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  dohvatiSvaPodrucjaznanja(){
    this._ishodNastavneJedinicePopisService.dohvatiAktivnaPodrucjaznanja({'idkorisnik': localStorage.getItem('userId')}).subscribe(res=>{
      // console.log(res);
      if (res.success == true) {
        this.svapodrucjaznanja = res.data[0];
      } else {
        this.svapodrucjaznanja = [];
      }
    })
  }

  odaberiIshod(ishodiucenjaForma){
    // $('#ishodiNastavneJediniceTablica').DataTable().clear();
    $('#ishodiNastavneJediniceTablica').DataTable().destroy();
    this.dohvatiIshode(ishodiucenjaForma);
  }

  dohvatiIshode(ishodiucenjaForma){
    this.dodajIshodGumb = true;
    this.idPodrucjeZnanjaPrivremeno = ishodiucenjaForma.podrucjeZnanja;
    this._ishodNastavneJedinicePopisService.dohvati_sve_ishode_nastavnih_jedinica({'idpodrucjeznanja':this.idPodrucjeZnanjaPrivremeno}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        this.ishodiNastavneJedinice = [];
        if(res.data.length > 0){
          this.imaIshoda = true;
          for(let i = 0; i < res.data.length; i++){
            if(res.data[i].idishodinastavnihjedinica != null){
              this.ishodiNastavneJedinice.push(res.data[i]);
            }
          }
          this.ishodiNastavneJediniceTrigger.next();
          $(document).ready(function(){
            var groupColumn = 1;
            var table = $('#ishodiNastavneJediniceTablica').DataTable({
              "columnDefs": [
                  { "visible": false, "targets": groupColumn }
              ],
              // "order": [[ groupColumn, 'asc' ]],
              "displayLength": 25,
              "drawCallback": function( settings ){
                var api = this.api();
                var rows = api.rows( {page:'current'} ).nodes();
                var last = null;
      
                api.column(groupColumn, {page:'current'} ).data().each( function ( group, i ){
                  if( last !== group ){
                    $(rows).eq( i ).before(
                      '<tr class="group"><td colspan="4">'+group+'</td></tr>'
                    );
                    last = group;
                  }
                });
              }
            });
          });
        } else {
          this.imaIshoda = false;
          toastr.error("Nema podataka!");
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  odaberiNastavnuJedinicu(ishodiucenjaForma){
    // console.log(ishodiucenjaForma);
    this.idNastavnaJedinica = ishodiucenjaForma.idNastavnaJedinica;
  }

  obrisiIshod(ishod){
    // console.log(ishod);
    let _this2 = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati ovaj ishod nastavne jedinice?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        _this2._ishodNastavneJedinicePopisService.obrisi_ishode_nastavnih_jedinica({'idishodinastavnihjedinica': ishod.idishodinastavnihjedinica}).subscribe(res => {
          // console.log(res);
          if(res.success == true){
            toastr.success("Ishod uspješno obrisan!");
            $('#ishodiNastavneJediniceTablica').DataTable().clear();
            $('#ishodiNastavneJediniceTablica').DataTable().destroy();
            _this2.odaberiIshod({'podrucjeZnanja': ishod.podrucjeznanja_idpodrucjeznanja});
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja.');
    });
  }

  pripremiPodatkeIshod(ishod){
    // console.log(ishod);
    this.ishodNastavneJediniceEditForma = this._fb.group({
      idishodinastavnihjedinica: ishod.idnastavnajedinica,
      ishodinaziv: ishod.inj_ishodinaziv,
      idmodul: ishod.idishodinastavnihjedinica
    });
    // console.log(this.ishodNastavneJediniceEditForma);
  }

  urediIshod(ishod){
    // console.log(ishod);
    let podaciZaEdit = {
      'idishodinastavnihjedinica': ishod.idmodul,
      'idmodul': ishod.idishodinastavnihjedinica,
      'ishodinaziv': ishod.ishodinaziv
    };
    // console.log(podaciZaEdit);
    this._ishodNastavneJedinicePopisService.uredi_ishode_nastavnih_jedinica(podaciZaEdit).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        toastr.success(res.message);
        $('#ishodiNastavneJediniceTablica').DataTable().clear();
        $('#ishodiNastavneJediniceTablica').DataTable().destroy();
        this.odaberiIshod({'podrucjeZnanja': this.idPodrucjeZnanjaPrivremeno});
      } else {
        toastr.error(res.message);
      }
    });
  }

  dodajIshod(ishod){
    // console.log(ishod);
    let podaciZaSlanje = {
      'ishodinaziv': ishod.sadrzaj,
      'idmodul': this.idNastavnaJedinica /* this.idPodrucjeZnanjaPrivremeno */
    }
    // console.log(podaciZaSlanje);
    if(this.idNastavnaJedinica != null){
      this._ishodNastavneJedinicePopisService.spremi_ishode_nastavnih_jedinica(podaciZaSlanje).subscribe(res => {
        // console.log(res);
        if(res.success == true){
          $('#ishodiNastavneJediniceTablica').DataTable().clear();
          $('#ishodiNastavneJediniceTablica').DataTable().destroy();
          this.odaberiIshod({'podrucjeZnanja': this.idPodrucjeZnanjaPrivremeno});
          this.idNastavnaJedinica = null;
        }
      });
    } else {
      toastr.error('Odaberite nastavnu jedinicu.');
    }
    
  }


}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ishod-nastavnejedinice-popis/ishod-nastavnejedinice-popis.component.ts